module.exports = __webpack_public_path__ + "static/media/nitsilchar.fde33de7.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/ContactUs/static/images/brands/nitsilchar.png
// module id = 71
// module chunks = 1